







import Vue from 'vue'
import LinkButton from '@/components/shared/atoms/Button/LinkButton'

export default Vue.extend({
  components: {
    LinkButton
  },
  props: {
    eventId: {
      type: Number,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    uchinokoResultPath(): string {
      return `/events/${this.eventId}/uchinoko`
    }
  },
  methods: {
    handleClick() {
      this.$emit('click')
    }
  }
})
